import { useHideDOMElement } from "./useHideDOMElement";

export const useHideCommunitySwitcher = () =>
  useHideDOMElement(".community__switcher");
